import * as React from 'react';

import {action, computed, observable} from "mobx";

import './CodewordLock.pcss';
import {observer} from "mobx-react";
import {API} from "api";

interface Props {
  feedItem:any;
  onSuccessFullUnlock:(feedItem:any)=>void;
}

// TODO: trim & case insensitive codewords

@observer
export class CodewordLock extends React.Component<Props> {

  @observable _needsUnlocking = false;
  @observable codeword = "";
  @observable checkingCodeword = false;
  @observable codewordIncorrect = false;
  checkStart;

  constructor(props:Props) {
    super(props);
    if(props.feedItem._post) {
      if(!!props.feedItem._post.lockedWithCodeword) {
        if(!props.feedItem.unlockedDate) {
          this._needsUnlocking = true;
        }
      }
    }
  }

  @computed get codewordInstructions() {
    if(this.props.feedItem._post && this.props.feedItem._post.codewordInstructions) {
      return this.props.feedItem._post.codewordInstructions;
    }
    return "The codeword was spoken by the presenter during the session";
  }

  @computed get codewordInstructionsTitle() {
    if(this.props.feedItem._post && this.props.feedItem._post.codewordInstructionsTitle) {
      return this.props.feedItem._post.codewordInstructionsTitle;
    }
    return "Enter the codeword to unlock the quiz";
  }

  @computed get needsUnlocking() {
    return this._needsUnlocking;
  }

  @computed get disableUnlockButton() {
    return this.codeword.trim().length < 3;
  }

  @action unlock = () => {
    if (!this.checkingCodeword) {
      this.checkingCodeword = true;
      this.checkStart = new Date().getTime();
      API.post('/codeword', {feedItemId:this.props.feedItem._id, codeword:this.codeword})
        .then((response)=>{
          this.handleUnlockResponse(response);
        })
        .catch(e => {
          this.checkingCodeword = false;
          alert("Failed to unlock post!");
        });
    }
  }

  @action handleUnlockResponse = (response) => {
    const elapsed = new Date().getTime() - this.checkStart;
    if (elapsed >= 1000) {
      this.checkingCodeword = false;
      if(response.success) {
        this.codeword = "";
        this._needsUnlocking = false;
        this.props.feedItem.unlockedDate = response.feedItem.unlockedDate;
      } else {
        this.codewordIncorrect = true;
      }
    } else {
      setTimeout(() => {
        this.handleUnlockResponse(response);
      }, 1000 - elapsed);
    }
  }

  render() {
    if (!this._needsUnlocking) {
      return null;
    } else {
      return (
        <div className={'codeword-lock'}>
          <div className={'unlock-feed-item'}>
            <div><span className={'material-icons'}>lock</span></div>
            <h2 className={'level2 shadow'}>{this.codewordInstructionsTitle}</h2>
            <p>{this.codewordInstructions}</p>
            <div className={"codeword-form"}>
              <input
                disabled={this.checkingCodeword}
                type={'text'}
                className={`code${this.codewordIncorrect?' error':''}`}
                placeholder={'enter codeword'}
                value={this.codeword} onChange={(e) => {
                  this.codeword = e.target.value;
                }}
              />
              <button disabled={this.disableUnlockButton || this.checkingCodeword}
                      onClick={this.unlock}>{this.checkingCodeword ? 'checking, please wait...' : 'Unlock'}</button>
            </div>
            {this.codewordIncorrect && <p className={'error'}>The codeword you entered is incorrect</p>}
          </div>
        </div>
      );
    }
  }
}